import { string, shape, oneOf } from 'prop-types';
import StyledLabel from '../styled-label';

const PT_ITEM = shape({
  aria_label: string,
  display_text: string,
  name: string,
  value: string,
}).isRequired;

const PT_ITEMS = shape({
  items: PT_ITEM,
});

const PT_INFOMODAL = shape({
  title: StyledLabel.propTypes,
  subtitle: StyledLabel.propTypes,
  action: StyledLabel.propTypes,
  type: oneOf(['small', 'large', 'full', 'card']),
  items: PT_ITEM,
});

const DF_INFOMODAL = {
  type: 'small',
};

export { PT_ITEMS, PT_INFOMODAL, DF_INFOMODAL };
